import { Carousel } from 'primereact/carousel';
import React, { useMemo, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useGetParticipantRoleTypesQuery } from '../../api/misc.js';
import BaseButton from '../form/BaseButton.jsx';
import IconAi from '../images/IconAi.jsx';
import BaseCard from './BaseCard.jsx';
import MeetingAttendeeInfoEdit from './MeetingAttendeeInfoEdit.jsx';
import ReactMarkdown from 'react-markdown';

const ParticipantsCarousel = ({ className, calendarMeetingId, items, edit = false, control, clearErrors, page }) => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [selectedParticipant, setSelectedParticipant] = useState(null);
    const { data: participantRoleTypes } = useGetParticipantRoleTypesQuery({});
    const roleOptions = useMemo(() => {
        if (participantRoleTypes?.response?.participant_role_types) {
            return participantRoleTypes.response.participant_role_types;
        }

        return [];
    }, [participantRoleTypes]);

    const handleEditOverlay = (participant) => {
        setSelectedParticipant(participant);
        setShowOverlay(true);
    };

    const participantTemplate = (item) => {
        const index = items.findIndex((obj) => obj.id === item.id);

        return (
            <BaseCard className='mt-0 mb-6 shadow-none'>
                <div className='flex flex-row items-center mb-4'>
                    <div className='mr-4'>
                        {item && (
                            <div className='rounded-full w-20 h-20 overflow-hidden'>
                                <div className='w-full h-full bg-theme1-pale flex items-center justify-center'>
                                    <div className='text-theme1-primary font-bold text-3xl'>
                                        {`${item.contact?.first_name?.substring(0, 1).toUpperCase() || ''}${item.contact?.last_name?.substring(0, 1).toUpperCase() || ''}`}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='flex-1'>
                        <div className='flex items-center'>
                            {item && (
                                <div className='text-theme1-primary font-bold text-2xl'>
                                    {item.contact?.first_name} {item.contact?.last_name}
                                </div>
                            )}
                        </div>
                        {item && item.role && (
                            <div className='text-sm text-theme1-title2 font-bold mt-1'>
                                {roleOptions.find((role) => role.value === item.role)?.label}
                            </div>
                        )}
                        {item && item.contact?.companies?.length > 0 && (
                            <div className='text-sm text-theme1-primary2 font-bold mt-1 leading-none'>
                                {item.contact?.companies?.[0].job_title}
                            </div>
                        )}
                        {item && item.contact?.companies?.length > 0 && (
                            <div className='mt-1 text-base font-bold text-theme1-text2'>
                                {item.contact?.companies?.[0].name}
                            </div>
                        )}
                    </div>
                </div>
                {item && item.info && <div className='text-theme1-text1 mt-1 whitespace-pre-wrap'>{item.info}</div>}
                {item && !item.info && item.openai_info && (
                    <div>
                        <div className='w-6 h-6 mr-2 flex items-center justify-center float-left'>
                            <IconAi className='-mt-1 fill-theme1-gold stroke-theme1-gold' />
                        </div>
                        <div className='text-theme1-text1 mt-1 whitespace-pre-wrap'>
                            <ReactMarkdown>{item.openai_info}</ReactMarkdown>
                        </div>
                    </div>
                )}

                <BaseButton
                    className='mt-8 btn-red-outline'
                    onClick={() => handleEditOverlay(item)}
                    textValue='Edit Info'
                />
            </BaseCard>
        );
    };

    return (
        <div className={twMerge('', className)}>
            <Carousel
                value={items}
                numScroll={1}
                numVisible={1}
                itemTemplate={participantTemplate}
                showNavigators={false}
                circular={false}
                showIndicators
                page={page || 0}
            />

            {selectedParticipant && (
                <MeetingAttendeeInfoEdit
                    calendarMeetingId={calendarMeetingId}
                    attendeeId={selectedParticipant.participant_id}
                    attendeeCustomInfo={selectedParticipant.info}
                    attendeeAiInfo={selectedParticipant.openai_info}
                    showOverlay={showOverlay}
                    setShowOverlay={setShowOverlay}
                />
            )}
        </div>
    );
};

export default ParticipantsCarousel;
